<template>
  <div class="feedBack-component">
    <div class="feedBack-content">
      <div class="title">有道云听意见反馈</div>
      <div class="tips">
        为了给您提供更好的服务，希望您能抽出几分钟时间，将您的感受和建议告诉我们，我们非常重视每位用户的宝贵意见，期待您的参与！现在马上开始吧！
      </div>
      <!-- <div :class="['feed-item', data[item.id].isError ? 'feed-item-error' : '']">
        <div class="feed-item-title">
          1.您对我们的产品有哪些问题或者建议
          <span  class="is-required">*</span>
        </div>
        <a-textarea @change='inputComments' class="feed-input" :value='data.contact.value' placeholder="请输入邮箱" />
        <div class="error-msg" v-if="data.comments.isError">{{ data.comments.errorMsg }}</div>
      </div> -->
      <div
        :class="['feed-item', data[item.id].isError ? 'feed-item-error' : '']"
        v-for="(item, index) in config"
        :key="item.id"
      >
        <div class="feed-item-title">
          {{ index + 1 }}.{{ item.title }}
          <span v-if="item.isRequire" class="is-required">*</span>
        </div>
        <a-textarea v-if="item.textarea" v-bind="item.props" v-on="item.funcs"></a-textarea>
        <a-input v-if="item.input" v-bind="item.props" v-on="item.funcs"></a-input>
        <div class="error-msg" v-if="data[item.id].isError">{{ data[item.id].errorMsg }}</div>
      </div>

      <div @click="commit" data-rlog="feedback_submit" class="commit-btn">提交</div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { message } from 'ant-design-vue';
import services from '../../services';
import './index.scss';
import { checkFileTitle } from '../../utils/utils';

const data = reactive({
  comments: {
    value: '',
    isError: false,
    errorMsg: '请输入问题或者建议',
  },
  contact: {
    value: '',
    errorMsg: '请输入正确的邮箱',
    isError: false,
  },
});
function checkComments() {
  const errorMsg = checkFileTitle(data.comments.value, '请输入问题或者建议', { len: 200 });
  // 没有直接不允许输入，只是提示给用户不允许特殊然后手动删除
  if (errorMsg) {
    data.comments = {
      ...data.comments,
      errorMsg,
      isError: true,
    };
  } else {
    data.comments.isError = false;
  }
  return data.comments.isError;
}

function inputComments(e) {
  data.comments.value = e.target.value;
  checkComments();
}

function checkContact() {
  const strReg = /^\w+((-\w+)|(\.\w+))*@{1}\w+\.{1}\w{2,4}(\.{0,1}\w{2}){0,1}/gi;
  if (data.contact.value) {
    data.contact.isError = !strReg.test(data.contact.value);
  } else {
    data.contact.isError = false;
  }
  return data.contact.isError;
}
function inputContact(e) {
  data.contact.value = e.target.value;
  checkContact();
}
// const comments = ref(data.comments.value)
// const contact = ref(data.contact.value)

const config = [
  {
    id: 'comments',
    title: '您对我们的产品有哪些问题或者建议',
    isRequire: true,
    textarea: true,
    props: {
      class: 'feed-textinput feed-input',
      'v-model:value': data.comments.value,
      placeholder: '请留下您的宝贵建议',
    },
    funcs: {
      change: inputComments,
    },
    checkIsError: checkComments,
  },
  {
    id: 'contact',
    title: '请留下您的邮箱，我们会尽快为您答复',
    input: true,
    props: {
      class: 'feed-input',
      'v-model:value': data.contact.value,
      placeholder: '请输入邮箱',
    },
    funcs: {
      change: inputContact,
    },
    checkIsError: checkContact,
  },
];

function submit() {
  const { VUE_APP_FEEDBACK_URL } = process.env;
  services
    .post(
      VUE_APP_FEEDBACK_URL,
      {
        product: 'cloud_voice',
        client: 'web',
        appVersion: '2.2.0',
        comments: data.comments.value,
        contact: data.contact.value,
      },
      { errorToast: true }
    )
    .then(res => {
      if (res.code === 0) {
        message.success({ content: '反馈成功' });
      }
    });
}
function commit() {
  let isError = false;
  for (let i = 0; i < config.length; i += 1) {
    const { checkIsError } = config[i];
    if (checkIsError && checkIsError()) {
      isError = true;
      break;
    }
  }
  if (!isError) {
    submit();
  }
}
</script>
